export default "__VITE_ASSET__c4400266__"